import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'client/js/util/modal';
import { useCreateItem } from './hooks/use_filemanager';

const CreateItemModal = ({ currentPath, onClose, baseApiUrl }) => {
  const [name, setName] = useState('');
  const [type, setType] = useState('directory');
  const createItemMutation = useCreateItem(baseApiUrl);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert('Bitte geben Sie einen Namen ein');
      return;
    }

    createItemMutation.mutate(
      { path: currentPath, name: name.trim(), type },
      {
        onSuccess: () => {
          onClose();
        },
      }
    );
  };

  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      contentLabel="Neues Element erstellen"
    >
      <div className="modal-header">
        <h5 className="modal-title">Neues Element erstellen</h5>
        <button type="button" className="close" onClick={onClose}>
          <span>&times;</span>
        </button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="item-type">Typ</label>
            <select
              id="item-type"
              className="form-control"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="directory">Ordner</option>
              <option value="file">Datei</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="item-name">Name</label>
            <input
              type="text"
              id="item-name"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={type === 'directory' ? 'Ordnername' : 'Dateiname'}
              autoFocus
            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Abbrechen
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={createItemMutation.isLoading}
          >
            {createItemMutation.isLoading ? 'Erstelle...' : 'Erstellen'}
          </button>
        </div>
      </form>
    </Modal>
  );
};

CreateItemModal.propTypes = {
  currentPath: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  baseApiUrl: PropTypes.string,
};

export default CreateItemModal;